import React, { Fragment } from 'react';
import T from 'prop-types';

import ShareModalContent from '../../../shared/components/ShareModalContent';
import Modal from '../../../../../../components/Modal';

const ShareReportModal = ({
  show,
  shareUrl,
  requestUrl,
  onHide,
}) => (
  <Modal
    open={show}
    size="xs"
    hideCloseButton
    shouldCloseOnOverlayClick={false}
    modalClassName="share-report-modal"
    onClose={() => onHide(false)}
  >
    {show && (
      <Fragment>
        <header className="share-report-modal__header">
          <p className="share-report-modal__header-title">Share Report</p>
          <span className="hicon-close" onClick={() => onHide(false)} />
        </header>
        <ShareModalContent
          shareUrl={shareUrl}
          requestUrl={requestUrl}
          onHide={onHide}
        />
      </Fragment>
    )}
  </Modal>
);

ShareReportModal.propTypes = {
  show: T.bool.isRequired,
  shareUrl: T.string.isRequired,
  requestUrl: T.string.isRequired,
  onHide: T.func.isRequired,
};

export default ShareReportModal;
